<template>
  <div class="first-title clearfix">
    <div class="title-left fl">
      <img class="title-left-img" src="../images/img_32389_0_307.png">
      <div class="title-left-text">
        {{message}}
        <div class="title-left-dot"></div>
      </div>      
    </div>
    <div class="title-right fr" @click="loadMore">
      更多···
    </div>
  </div>
</template>

<script>
  
  export default {
    data () {
      return {

      }
    },
    props: {
      message: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    methods: {
      loadMore() {
        if (this.type == 1) {
            this.$router.push({
              path: '/specialCourse',
              query: { 
                  }
            });
        } else if (this.type == 2){
            this.$router.push({
              path: '/teacher/list',
              query: { 
                  }
            });
        }
        
      }
    }
  }
</script>

<style lang="less" scoped>
.first-title {
  width: 1200px;
  margin: 50px 0;
  // left
  .title-left {
    position: relative;
    .title-left-img {
      width:34px;
      height:34px;
      position: absolute;
      left: 0;
      top: 0;
    }
    .title-left-text {
      width:120px;
      height:30px;
      font-size:30px;
      font-weight:400;
      color:rgba(21,34,48,1);
      line-height:45px;      
      position: relative;
      top: 12px;
      left: 12px;
      z-index: 2;
      .title-left-dot {
        width:7px;
        height:7px;
        background:rgba(6,126,242,1);
        position: absolute;
        right: -15px;
        bottom: -6px;
      }
    }
  }
  .title-right {
    font-size:16px;
    color:rgba(6,126,242,1);
    position: relative;
    top: 20px;
    cursor: pointer;
  }
}
</style>